'use strict';

var lastUID = 0;
var transformers = {};

module.exports = {

  getGUID: function () {
    var count =  ++lastUID;
    return 'layer' + count;
  }
};


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/transform/TransformUtil.js